var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeCrossed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.14 1.924 2.177 0 .737 1.414l1.747 1.71C1.562 3.995.77 5.132.106 6.535a1.108 1.108 0 0 0 0 .947c1.74 3.676 4.37 5.525 7.894 5.525 1.366 0 2.597-.277 3.693-.83L13.563 14l1.432-1.408-1.556-1.53-.055-.053-3.472-3.413-2.535-2.491-1.51-1.483-1.726-1.698ZM4 7.006c0-.693.177-1.345.487-1.914l1.55 1.526A2.002 2.002 0 0 0 8.424 8.96l1.551 1.525A4 4 0 0 1 4 7.006Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.995 6.816a4 4 0 0 0-3.873-3.808L6.253 1.172A8.954 8.954 0 0 1 8 1.006c3.525 0 6.154 1.85 7.894 5.526a1.124 1.124 0 0 1 0 .947c-.354.748-.744 1.42-1.171 2.017l-2.728-2.68Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeCrossed);
export default ForwardRef;